<footer class="fixed bottom-0 left-0 right-0 z-40 bg-brand-surface-card border-t border-brand-subtle shadow-sm">
  <div class="w-full min-h-16 flex flex-col sm:flex-row flex-wrap items-center justify-center gap-3 sm:gap-x-6 sm:gap-y-2 px-4 sm:px-6 lg:px-16 py-3 sm:py-0 text-sm text-brand-ink-secondary">
    <!-- Language Selector -->
    <select
      class="appearance-none border border-brand rounded-full px-3 py-1 pr-7 text-xs font-semibold text-brand-ink bg-brand-surface-card hover:bg-brand-surface transition bg-no-repeat bg-[length:10px_6px] bg-[position:right_8px_center] cursor-pointer order-1"
      style="background-image: url('data:image/svg+xml,&lt;svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 10 6%22&gt;&lt;path d=%22M0 0l5 6 5-6z%22 fill=%22%236b7280%22/&gt;&lt;/svg&gt;');"
      [attr.aria-label]="'FOOTER.SELECT_LANGUAGE' | translate"
      [(ngModel)]="selectedLanguage"
      (ngModelChange)="onLanguageChange($event)"
    >
      <option *ngFor="let lang of languageService.languages" [value]="lang.code">
        {{ lang.label }}
      </option>
    </select>

    <!-- Navigation Links -->
    <nav class="flex flex-wrap items-center justify-center gap-3 sm:gap-4 text-xs font-semibold uppercase tracking-wide text-brand-muted order-2 sm:order-2">
      <a [href]="landingPageUrl + '/contact'" class="hover:text-brand-primary transition">{{ 'FOOTER.CONTACT_US' | translate }}</a>
      <a [href]="landingPageUrl + '/terms-of-use'" class="hover:text-brand-primary transition">{{ 'FOOTER.TERMS_OF_USE' | translate }}</a>
      <a [href]="landingPageUrl + '/privacy-policy'" class="hover:text-brand-primary transition">{{ 'FOOTER.PRIVACY' | translate }}</a>
      <a [href]="landingPageUrl + '/intellectual-property'" class="hover:text-brand-primary transition hidden sm:inline">{{ 'FOOTER.INTELLECTUAL_PROPERTY' | translate }}</a>
      <a [href]="landingPageUrl + '/trust'" class="hover:text-brand-primary transition hidden md:inline">{{ 'FOOTER.TRUST' | translate }}</a>
    </nav>

    <!-- Copyright -->
    <span class="text-xs text-brand-muted-light whitespace-nowrap order-3 w-full sm:w-auto text-center sm:text-left">
      {{ 'FOOTER.COPYRIGHT' | translate: { year: currentYear } }}
    </span>
  </div>
</footer>
